(function ($) {
  // noConflict モード: ここから下では $ で jQuery を使用
  class Top {
    constructor(el,opt){
      this.el = el;
      if($("." + this.el).length > 0){
        this.event();
      }
    }
    event(){
    }
  }
  
  class Accordion {
    constructor(el,opt){
      this.el = el;
      if($("." + this.el).length > 0){
        this.event();
      }
    }
    event(){
      $('.' + this.el).click(function() {
         $(this).next().slideToggle(Number($('html').data('transition')));
         $(this).toggleClass('is-active');
      })
    }
  }
    // ------------------------------------------
  // お問い合わせ確認画面：「入力画面へ戻る」ボタン
  // プラグイン側が相対URL設定時に戻るボタンを非表示にしてしまうため、明示的に表示・遷移させる
  // ------------------------------------------
  class ContactConfirm {
    constructor(el) {
      this.btn = document.querySelector(el);
      if (this.btn) {
        this.init();
      }
    }
  
    init() {
      this.btn.style.setProperty('display', 'block', 'important');
      this.btn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopImmediatePropagation();
        window.location.href = '/contact/';
      }, true);
    }
  }
  
    // ------------------------------------------
  // お問い合わせフォーム：水曜日を選択不可（ピッカー上でグレーアウト）
  // ------------------------------------------
  class ContactDate {
    constructor(el) {
      this.inputs = document.querySelectorAll(el || 'input[type="date"]');
      if (this.inputs.length > 0 && typeof flatpickr !== 'undefined') {
        this.init();
      }
    }
  
    // 水曜日(3)は定休日
    isWednesday(date) {
      return date.getDay() === 3;
    }
  
    init() {
      this.inputs.forEach((input) => {
        // ネイティブのdateピッカーが出ないよう、flatpickr側に置き換える
        input.type = 'text';
        input.placeholder = '年 / 月 / 日';
        flatpickr(input, {
          locale: 'ja',
          dateFormat: 'Y-m-d', // 送信される値
          altInput: true, // 画面上の表示用inputを別に生成
          altFormat: 'Y年n月j日',
          altInputClass: 'c-form__date',
          minDate: input.min || null,
          maxDate: input.max || null,
          disable: [(date) => this.isWednesday(date)],
          disableMobile: true,
        });
      });
    }
  }
  
    // 参考サイト
  // https://hacknote.jp/archives/15289/
  
  let cookie = {
  	/**
  	 * 取得
  	 * @param {string} cookieName 取得するCookieの名前
  	 */
  	get : function(cookieName) {
  		if (!navigator.cookieEnabled) return false;
  
  		var getCookieAllData  = document.cookie,
  		    getCookieAllDatas = getCookieAllData.split(';'),
  		    getCookieDatas    = {},
  		    cookieKeyValue    = [],
  		    cookieKey         = '',
  		    cookieValue       = '';
  
  		var hashLength = function(arr) {
  			var result = 0, key = false;
  
  			if (typeof arr !== 'object') return false;
  
  			for (key in arr) result++;
  
  			return result;
  		};
  
  		for (var i = 0, len = getCookieAllDatas.length; i < len; i++) {
  			if (getCookieAllDatas[i] && getCookieAllDatas[i] !== '') {
  				cookieKeyValue = getCookieAllDatas[i].split('=');
  				cookieKey      = cookieKeyValue[0].replace(/^\s+/, '');
  				cookieValue    = '';
  
  				if (cookieKeyValue[1]) {
  					cookieValue = decodeURIComponent(cookieKeyValue[1]);
  				}
  
  				getCookieDatas[cookieKey] = cookieValue;
  			}
  		}
  
  		if (hashLength(getCookieDatas) > 0) {
  			if (cookieName && cookieName in getCookieDatas) {
  				return getCookieDatas[cookieName];
  			} else {
  				return getCookieDatas;
  			}
  		} else {
  			return '';
  		}
  	},
  
  	/**
  	 * 設定
  	 * @param {string} cookieName 設定するCookieの名前
  	 * @param {string} value 設定する値
  	 * @param {string} domain 有効ドメイン
  	 * @param {string} path 有効パス
  	 * @param {string} expires 有効期限
  	 * @param {boolean} secure セキュアとするか
  	 * @return {boolean} 設定に成功した場合はtrue、失敗した場合はfalseを返す
  	 */
  	set : function(cookieName, value, domain, path, expires, secure) {
  		if (!navigator.cookieEnabled || !cookieName || !value) return false;
  
  		var date, dt, ts, ts_after;
  
  		var setCookieData = cookieName + '=' + encodeURIComponent(value) + ';';
  
  		if (domain) setCookieData += 'domain=' + domain + ';';
  
  		if (path) setCookieData += 'path=' + path + ';';
  
  		if (expires) {
        dt = new Date();
        ts = dt.getTime();
  
        // 1時間後
        ts_after = ts + (1000 * 60 * 60 * expires);
  
        date = new Date(ts_after);
  			setCookieData += 'expires=' + date.toGMTString() + ';';
  		}
  
  		if (secure && secure === true && location.protocol.match(/https/)) {
  			setCookieData += 'secure';
  		}
  
  		document.cookie = setCookieData;
  
  		return true;
  	},
  
  	/**
  	 * 削除
  	 * @param {string} cookieName 削除するCookieの名前
  	 * @return {boolean} 削除に成功した場合はtrue、失敗した場合はfalseを返す
  	 */
  	del : function(cookieName) {
  		if (!navigator.cookieEnabled || !cookieName) return false;
  
  		var getCookieDatas = this.get();
  
  		if (getCookieDatas[cookieName]) {
  			var setCookieData = cookieName + '=;',
  			    date          = new Date(0);
  
  			setCookieData += 'expires=' + date.toGMTString() + '';
  
  			document.cookie = setCookieData;
  
  			return true;
  		}
  
  		return false;
  	}
  };
    class Editor {
    constructor(el,opt){
      this.el = el;
      if($("." + this.el).length > 0){
        this.event();
      }
    }
    event(){
      //------- サイドナビ アンカー ---------
      let options = {
        threshold: [0],
        rootMargin: '-49.9%',
      }
      const observerEnter = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          const item = entry.target;
          if(entry.intersectionRatio > 0){
            $(`.js-sideNav [href="#${$(item).attr('id')}"]`).siblings().removeClass('is-active')
            $(`.js-sideNav [href="#${$(item).attr('id')}"]`).addClass('is-active')
          } else {
            $(`.js-sideNav [href="#${$(item).attr('id')}"]`).removeClass('is-active')
          }
        })
      }, options)
  
      const anchorEl = document.querySelectorAll('[id*="anchor"]')
      anchorEl.forEach((e)=>{
        observerEnter.observe(e)
      })
  
      
      $('[id*="anchor"]').each(function() {
        let text = $(this).find('.anchorTitle').text();
        let id = $(this).attr('id');
        if(text) {
          let newElement = $(`<a href="#${id}" class="c-transition"><hr class="c-transition">${text}</a>`);
          $('.js-sideNav').append(newElement);
        }
      })
  
      $(".js-sideNav a").click(function() {
        setTimeout(() => {
          $(this).siblings().removeClass('is-active')
          $(this).addClass('is-active')
        }, 600)
      })
  
  
      //------- 〆サイドナビ アンカー ---------
  
      //------- 画像のheught,widthをrem化 ---------
      $('.text-editor img').each(function(index, el) {
        let width = $(el).attr('width')
        // $(el).attr('width')
        $(el).css({'width': `${width * 0.1 + 'rem'}`, 'height': `auto`})
      })
      //------- 画像のheught,widthをrem化 〆 ---------
  
      //------- アコーディオン ---------
      $('.js-editor-accordion .inner').css({'display': 'none'})
  
      $('.js-editor-accordion .trigger').on('click', function() {
        $(this).find('.trigger-icon').toggleClass('is-active')
        $(this).next().slideToggle(Number($('html').data('transition')))
      })
      //------- アコーディオン 〆 ---------
  
      //------- タブ切り替え ---------
      if($(window).innerWidth() >= '769') {
  
        //------- PCの場合 ---------
        $('.js-tab .inner > div > div:nth-of-type(n + 2)').css({'display': 'none'})
        $('.js-tab .trigger .elementor-element:nth-of-type(1)').addClass('is-active')
    
        $('.js-tab .trigger .elementor-element').on('click', function() {
          $(this).siblings().removeClass('is-active')
          $(this).addClass('is-active')
          $(this).closest('.js-tab').find('.inner-child').css({'display': 'none'})
          $(this).closest('.js-tab').find('.inner-child').eq($(this).index()).fadeIn(Number($('html').data('transition')))
        })
        //------- PCの場合 〆 ---------
  
      } else {
  
        //------- SPの場合 ---------
        $('.js-tab').each(function() {
          const _el = $(this)
          const trigger_child = _el.find('.trigger-child')
          _el.find('.inner-child').each(function(index) {
            $(this).before(trigger_child[index])
          })
        })
  
        $('<span></span>').appendTo('.trigger-child > div')
  
        $('.inner-child').css({'display': 'none'})
        $('.trigger-child').click(function() {
          $(this).find('span').toggleClass('is-active')
          $(this).next().slideToggle(Number($('html').data('transition')))
        })
        //------- SPの場合 〆 ---------
        
      }
      //------- タブ切り替え 〆 ---------
    }
  }
    // ------------------------------------------
  // よくあるご質問の開閉状態(aria-expanded)
  // 開閉アニメーションはテンプレートの Accordion.js
  // ------------------------------------------
  class FaqAccordion {
    constructor(el, opt) {
      this.btns = document.querySelectorAll('.' + el);
      if (this.btns.length > 0) {
        this.event();
      }
    }
    event() {
      this.btns.forEach((btn) => {
        btn.addEventListener('click', () => {
          const isOpen = btn.getAttribute('aria-expanded') === 'true';
          btn.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
        });
      });
    }
  }
  
    // ------------------------------------------
  // モーダル・メニューのフォーカス制御
  // ------------------------------------------
  class FocusTrap {
    constructor(container) {
      this.container = container;
      this.opener = null;
      this.onKeydown = this.onKeydown.bind(this);
    }
  
    focusables() {
      const selector = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
      return Array.from(this.container.querySelectorAll(selector)).filter((el) => {
        if (el.closest('[aria-hidden="true"]') && el.closest('[aria-hidden="true"]') !== this.container) return false;
        return el.getClientRects().length > 0 && getComputedStyle(el).visibility !== 'hidden';
      });
    }
  
    activate(first) {
      this.opener = document.activeElement;
      document.addEventListener('keydown', this.onKeydown);
      const target = first || this.focusables()[0];
      if (target) target.focus({ preventScroll: true });
    }
  
    deactivate() {
      document.removeEventListener('keydown', this.onKeydown);
      if (this.opener && typeof this.opener.focus === 'function') {
        this.opener.focus({ preventScroll: true });
      }
      this.opener = null;
    }
  
    onKeydown(e) {
      if (e.key !== 'Tab') return;
      const items = this.focusables();
      if (items.length === 0) {
        e.preventDefault();
        return;
      }
      const first = items[0];
      const last = items[items.length - 1];
      const active = document.activeElement;
  
      if (e.shiftKey && (active === first || !this.container.contains(active))) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && (active === last || !this.container.contains(active))) {
        e.preventDefault();
        first.focus();
      }
    }
  }
  
    class FormConvert {
    constructor(el,opt){
      this.el = el;
      if($("." + this.el).length > 0){
        this.event();
      }
    }
    event(){
      //全角から半角
      function replaceZtoH(str){
        str = str.replace(/[！-～]/g, function(s){
          return String.fromCharCode(s.charCodeAt(0) - 0xFEE0);
        });
        str = str.replace(/[-－﹣−‐⁃‑‒–—﹘―⎯⏤ーｰ─━]/g, '-');
        return str;
      }
      const el = document.querySelector('.js-convert');
      el.addEventListener('blur', () => {
        const br = el.value;
        const ar = replaceZtoH(br);
        el.value = ar;
      });
    }
  }
  
    // ------------------------------------------
  // FVのスクロール演出
  // ------------------------------------------
  class FvScroll {
    constructor(el, opt) {
      this.root = document.querySelector('.' + el);
      if (this.root) {
        this.event();
      }
    }
  
    event() {
      const fv = this.root;
      if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') return;
  
      gsap.registerPlugin(ScrollTrigger);
  
      const body = document.body;
      const shade = fv.querySelector('.js-fv-shade');
      const shadeBlur = fv.querySelector('.js-fv-shade-blur');
      const hero = fv.querySelector('.js-fv-hero');
      const pagination = fv.querySelector('.js-fv-pagination');
      const lead = fv.querySelector('.js-fv-lead');
      const concept = fv.querySelector('.js-fv-concept');
  
      const mm = gsap.matchMedia();
      mm.add({ isSp: '(max-width: 767px)', isPc: '(min-width: 768px)' }, (context) => {
        const { isSp } = context.conditions;
        const blurIn = 0.5;
        const heroFadeStart = isSp ? 0.35 : 0.62;
        const heroFade = isSp ? 0.4 : 0.26;
        // SPは1スクロール程度で演出が見えるよう距離を短くする
        const scrollLength = isSp ? 0.9 : 1.6;
        const scrub = isSp ? 0.6 : 1.5;
        const tl = gsap.timeline({
          defaults: { ease: 'none' },
          onUpdate: () => {
            if (isScrollLocked()) return;
            body.classList.toggle('is-fv-blur', tl.progress() >= heroFadeStart + heroFade);
          },
          scrollTrigger: {
            trigger: lead,
            start: 'top top',
            end: () => `+=${window.innerHeight * scrollLength}`,
            scrub,
            invalidateOnRefresh: true,
          },
        });
  
        const header = document.querySelector('.js-header');
        ScrollTrigger.create({
          trigger: fv,
          start: 'bottom bottom',
          onEnter: () => {
            if (isScrollLocked()) return;
            body.classList.add('is-fv-passed');
            if (header) header.classList.add('is-hidden');
          },
          onLeaveBack: () => {
            if (isScrollLocked()) return;
            body.classList.remove('is-fv-passed');
          },
        });
  
        tl.to(pagination, { autoAlpha: 0, duration: 0.4 }, 0)
          .to(shade, { opacity: 0, duration: blurIn }, 0)
          .to(shadeBlur, { opacity: 1, duration: blurIn }, 0)
          .to(hero, { autoAlpha: 0, duration: heroFade }, heroFadeStart);
  
        gsap.fromTo(concept, { autoAlpha: 0 }, {
          autoAlpha: 1,
          ease: 'none',
          scrollTrigger: {
            trigger: concept,
            start: 'top 100%',
            end: 'top 60%',
            scrub: 1,
          },
        });
  
        return () => body.classList.remove('is-fv-blur', 'is-fv-passed');
      });
    }
  }
  
    // ------------------------------------------
  // FVスライダー
  // ------------------------------------------
  class FvSlider {
    constructor(el, opt) {
      this.root = document.querySelector('.' + el);
      if (!this.root) return;
  
      this.slides = Array.from(this.root.querySelectorAll('.js-fv-slide'));
      this.pages = Array.from(this.root.querySelectorAll('.js-fv-page'));
      this.interval = (opt && opt.interval) || 6000;
      this.current = 0;
      this.timer = null;
  
      if (this.slides.length < 2) return;
      this.event();
    }
  
    event() {
      this.root.style.setProperty('--fv-interval', this.interval + 'ms');
  
      this.pages.forEach((page, index) => {
        page.addEventListener('click', () => {
          this.goTo(index);
          this.start();
        });
      });
  
      document.addEventListener('visibilitychange', () => {
        document.hidden ? this.stop() : this.start();
      });
  
      const firstImgs = this.slides[0].querySelectorAll('img');
      const zoomed = CSS.supports('-moz-appearance', 'none') ? 'scale(1.08) rotate(0.02deg)' : 'scale(1.08)';
      firstImgs.forEach((img) => {
        img.style.transition = 'none';
        img.style.transform = zoomed;
      });
      void this.slides[0].offsetWidth;
      firstImgs.forEach((img) => {
        img.style.transition = '';
        img.style.transform = '';
      });
  
      this.goTo(0);
      this.start();
    }
  
    goTo(index) {
      this.slides[this.current].classList.remove('is-active');
      if (this.pages[this.current]) {
        this.pages[this.current].classList.remove('is-active');
        this.pages[this.current].removeAttribute('aria-current');
      }
  
      this.current = index;
      this.slides[index].classList.add('is-active');
  
      const page = this.pages[index];
      if (page) {
        void page.offsetWidth;
        page.classList.add('is-active');
        page.setAttribute('aria-current', 'true');
      }
    }
  
    start() {
      this.stop();
      this.timer = setInterval(() => {
        this.goTo((this.current + 1) % this.slides.length);
      }, this.interval);
    }
  
    stop() {
      clearInterval(this.timer);
    }
  }
  
    // ------------------------------------------
  // ヘッダー
  // ------------------------------------------
  class Header {
    constructor(el) {
      this.header = document.querySelector('.' + el);
      if (!this.header) return;
  
      this.menu = document.querySelector('.js-menu');
      this.openBtns = document.querySelectorAll('.js-menu-open');
      this.isTop = this.header.classList.contains('is-top');
      this.isOverlay = this.header.classList.contains('is-overlay');
      this.isOpen = false;
      this.lastY = window.scrollY;
      if (this.menu) {
        this.trap = new FocusTrap(this.menu.querySelector('[role="dialog"]') || this.menu);
      }
  
      this.event();
    }
  
    event() {
      if (this.menu) {
        this.openBtns.forEach((btn) => btn.addEventListener('click', () => this.open()));
        this.menu.querySelectorAll('.js-menu-close').forEach((btn) => btn.addEventListener('click', () => this.close()));
        this.menu.querySelectorAll('a').forEach((link) => link.addEventListener('click', () => this.close()));
        document.addEventListener('keydown', (e) => {
          if (e.key === 'Escape' && this.isOpen) this.close();
        });
      }
  
      window.addEventListener('scroll', () => this.onScroll(), { passive: true });
      this.updateOverlay();
      this.fixedCta();
    }
  
    updateOverlay() {
      if (!this.isOverlay) return;
      this.header.classList.toggle('is-scrolled', window.scrollY > 2);
    }
  
    fixedCta() {
      const cta = document.querySelector('.js-fixed-cta');
      const footer = document.querySelector('.js-footer');
      if (!cta || !footer) return;
  
      const observer = new IntersectionObserver((entries) => {
        cta.classList.toggle('is-footer', entries[0].isIntersecting);
      });
      observer.observe(footer);
    }
  
    onScroll() {
      if (this.isOpen) return;
      if (isScrollLocked()) return;
  
      const y = window.scrollY;
      const atTop = y <= 2;
      const inFv = this.isTop && !document.body.classList.contains('is-fv-passed');
  
      this.updateOverlay();
  
      // Works詳細は透過⇔通常の見た目切替のみ（隠さない）
      if (this.isOverlay || inFv) {
        this.header.classList.remove('is-hidden');
      } else if (y > this.lastY + 2 && y > this.header.offsetHeight) {
        this.header.classList.add('is-hidden');
      } else if (atTop || y < this.lastY - 2) {
        this.header.classList.remove('is-hidden');
      }
  
      this.lastY = y;
    }
  
    open() {
      if (this.isOpen) return;
      this.isOpen = true;
      this.menu.classList.add('is-open');
      this.menu.setAttribute('aria-hidden', 'false');
      this.openBtns.forEach((btn) => btn.setAttribute('aria-expanded', 'true'));
      lockBodyScroll();
      this.trap.activate(this.menu.querySelector('.c-drawer__close'));
    }
  
    close() {
      if (!this.isOpen) return;
      this.isOpen = false;
      this.menu.classList.remove('is-open');
      this.menu.setAttribute('aria-hidden', 'true');
      this.openBtns.forEach((btn) => btn.setAttribute('aria-expanded', 'false'));
      unlockBodyScroll();
      this.trap.deactivate();
      this.lastY = window.scrollY;
      this.updateOverlay();
    }
  }
  
    // ------------------------------------------
  // アイデア集のモーダル（開いた1件のみ表示）
  // ------------------------------------------
  class IdeaModal {
    constructor(el, opt) {
      this.modal = document.querySelector('.' + el);
      if (this.modal) {
        this.slides = this.modal.querySelectorAll('.js-idea-slide');
        this.box = this.modal.querySelector('.js-idea-box');
        this.closeBtn = this.modal.querySelector('.p-idea__modal-close');
        this.index = 0;
        this.trap = new FocusTrap(this.modal.querySelector('[role="dialog"]') || this.modal);
        this.event();
      }
    }
  
    event() {
      document.querySelectorAll('.js-idea-open').forEach((btn) => {
        btn.addEventListener('click', () => this.open(Number(btn.dataset.index) || 0));
      });
  
      this.modal.querySelectorAll('.js-idea-close').forEach((btn) => {
        btn.addEventListener('click', () => this.close());
      });
  
      document.addEventListener('keydown', (e) => {
        if (!this.modal.classList.contains('is-open')) return;
        if (e.key === 'Escape') this.close();
      });
    }
  
    open(index) {
      this.show(index);
      this.modal.classList.add('is-open');
      this.modal.setAttribute('aria-hidden', 'false');
      lockBodyScroll();
      this.trap.activate(this.closeBtn);
    }
  
    close() {
      if (!this.modal.classList.contains('is-open')) return;
      this.modal.classList.remove('is-open');
      this.modal.setAttribute('aria-hidden', 'true');
      unlockBodyScroll();
      this.trap.deactivate();
    }
  
    show(index) {
      const total = this.slides.length;
      if (!total) return;
      this.index = ((index % total) + total) % total;
      this.slides.forEach((slide, i) => {
        slide.classList.toggle('is-active', i === this.index);
      });
      this.box.scrollTop = 0;
    }
  }
  
    // ------------------------------------------
  // imgタグに「js-parallax」クラス、そのimgタグに要素をラップしてheightを指定すると、画像がはみ出た分が動く
  // 「data-scrub」属性に数字を入れると、動きの滑らかさが変わる
  // ------------------------------------------
  class ImgParallax {
    constructor(el,opt){
      this.el = el;
      if($("." + this.el).length > 0){
        this.event();
      }
    }
    event(){
      let cls = this.el;
      let para_ele = document.querySelectorAll("." + this.el);
      para_ele.forEach((ele, index)=> {
        let property,scrub;
  
        $(ele).css({
          'object-fit':'cover',
          'object-position':'50% 0%',
          'width':'100%',
          'height':'100%',
        })
  
        property = '50% 100%';
        scrub = $(ele).data('scrub') ? $(ele).data('scrub') : 3;
  
        ele.classList.add(cls + index);
        gsap.to('.' + cls + index, {
          objectPosition: property,
          scrollTrigger: {
            trigger: '.' + cls + index, // 要素がビューポートに入ったときにアニメーション開始
            start: 'top bottom',
            end: 'bottom top',
            scrub: scrub,
            merker: true,
          }
        })
      })
    }
  }
  
    class InviewEvent {
    constructor(el, opt){
      this.el = "." + el;
      this.all = this.el + '-all';
      this.eachUp = this.el + '-each';
      this.eachItem = this.el + '-eachItem';
      this.eachItemFast = this.el + '-eachItem-fast';
      this.eachItemDelay = this.el + '-eachItem-delay';
      if($(this.el).length > 0){
        this.event();
      }
    }
    event() {
      let options = {
        threshold: [0, 0.05, 0.1, 1]
      }
      let optionsAll = {
        threshold: [0, 0.9, 1]
      }
      const observerEnter = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          const item = entry.target;
          if(entry.intersectionRatio >= 0.05){
            item.classList.add('is-inview');
            if(item.classList.contains('js-inview-each')){
              this.inviewEachUp(item);
            }
            if(item.classList.contains('js-inview-lottie')){
              this.inviewLottie(item);
            }
            observerEnter.unobserve(item);
          }
        });
      }, options);
      const observerAll = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          const item = entry.target;
          if(entry.intersectionRatio >= 0.9){
            item.classList.add('is-inview');
            if(item.classList.contains('js-inview-each')){
              this.inviewEachUp(item);
            }
            observerAll.unobserve(item);
          } else {
            item.classList.remove('is-inview');
          }
        });
      }, optionsAll);
      const inviewItem = document.querySelectorAll(this.el);
      const inviewAllItem = document.querySelectorAll(this.all);
      inviewItem.forEach((e)=>{
        observerEnter.observe(e);
      });
      inviewAllItem.forEach((e)=>{
        observerAll.observe(e);
      });
    }
    inviewEachUp(item){
      $(item).find(this.eachItem).each((i,el)=>{
        gsap.to($(el), {
          // duration: 0.8,
          // alpha: 1,
          delay: (0.2 * i),
          // y: 0,
          // x: 0,
          onComplete: ()=>{
            $(el).addClass('is-inview');
          }
        });
      });
      $(item).find(this.eachItemFast).each((i,el)=>{
        gsap.to($(el), {
          // duration: 0.8,
          // alpha: 1,
          delay: (0.1 * i),
          // y: 0,
          // x: 0,
          onComplete: ()=>{
            $(el).addClass('is-inview');
          }
        });
      });
      $(item).find(this.eachItemDelay).each((i,el)=>{
        gsap.to($(el), {
          // duration: 0.8,
          // alpha: 1,
          delay: (0.5 * i),
          // y: 0,
          // x: 0,
          onComplete: ()=>{
            $(el).addClass('is-inview');
          }
        });
      });
    }
    inviewLottie(item){
      if($(item).hasClass('js-lottie-flow')) {
        lottie.flow();
      }
      if($(item).hasClass('js-lottie-no01')) {
        lottie.no01();
      }
      if($(item).hasClass('js-lottie-no02')) {
        lottie.no02();
      }
      if($(item).hasClass('js-lottie-no03')) {
        lottie.no03();
      }
      if($(item).hasClass('js-lottie-no04')) {
        lottie.no04();
      }
      if($(item).hasClass('js-lottie-no05')) {
        lottie.no05();
      }
      if($(item).hasClass('js-lottie-no06')) {
        lottie.no06();
      }
      if($(item).hasClass('js-lottie-no07')) {
        lottie.no07();
      }
    }
  }
  
    // ------------------------------------------
  // 流れ続ける画像スライダー
  // ------------------------------------------
  class Marquee {
    constructor(el, opt) {
      this.items = document.querySelectorAll('.' + el);
      if (this.items.length > 0) {
        this.secondsPerItem = 20;
        this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.tracks = Array.from(this.items).map((item) => ({
          wrap: item,
          track: item.querySelector('.js-marquee-track'),
          originals: Array.from(item.querySelector('.js-marquee-track').children),
          x: 0,
          setWidth: 0,
          speed: 0,
          visible: false,
        }));
        this.tick = this.tick.bind(this);
        this.event();
      }
    }
  
    event() {
      this.build();
  
      let timer;
      window.addEventListener('resize', () => {
        clearTimeout(timer);
        timer = setTimeout(() => this.build(), 200);
      });
  
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          const s = this.tracks.find((item) => item.wrap === entry.target);
          if (s) s.visible = entry.isIntersecting;
        });
      }, { rootMargin: '100px 0px' });
      this.tracks.forEach((s) => observer.observe(s.wrap));
  
      requestAnimationFrame(this.tick);
    }
  
    build() {
      this.tracks.forEach((s) => {
        s.track.querySelectorAll('.is-clone').forEach((clone) => clone.remove());
  
        const first = s.originals[0];
        const last = s.originals[s.originals.length - 1];
        const gap = parseFloat(getComputedStyle(s.track).columnGap) || 0;
        s.setWidth = last.offsetLeft + last.offsetWidth + gap - first.offsetLeft;
        if (!s.setWidth) return;
        s.speed = this.reduced ? 0 : (s.setWidth / s.originals.length) / this.secondsPerItem;
  
        const copies = Math.ceil(s.wrap.clientWidth / s.setWidth) + 1;
        for (let i = 0; i < copies; i++) {
          s.originals.forEach((item) => {
            const clone = item.cloneNode(true);
            clone.classList.add('is-clone');
            clone.setAttribute('aria-hidden', 'true');
            s.track.appendChild(clone);
          });
        }
      });
    }
  
    tick(time) {
      const dt = Math.min(time - (this.last || time), 50) / 1000;
      this.last = time;
  
      this.tracks.forEach((s) => {
        if (!s.visible || !s.setWidth) return;
  
        s.x -= s.speed * dt;
        if (s.x <= -s.setWidth) s.x += s.setWidth;
        s.track.style.transform = `translate3d(${s.x}px, 0, 0)`;
      });
  
      requestAnimationFrame(this.tick);
    }
  }
  
    class Modal {
    constructor(el,opt){
      this.el = el;
      this.event();
      if($("." + this.el).length > 0){
        this.event();
      }
    }
    event(){
      $("." + this.el).on('click', function(e) {
        e.preventDefault();
        $(`[data-id='${$(this).attr('id')}']`).addClass('is-active');
        scrollBanOpen();
      })
  
      $("." + this.el + "-close").on('click', function() {
        $('.js-modal-container').removeClass('is-active');
        scrollBanClase();
      })
    }
  }
    // ------------------------------------------
  // お知らせのカテゴリータブ
  // ------------------------------------------
  class NewsTab {
    constructor(el, opt) {
      this.items = document.querySelectorAll('.' + el);
      if (this.items.length > 0) {
        this.event();
      }
    }
  
    event() {
      this.items.forEach((item) => {
        const tabs = Array.from(item.querySelectorAll('[role="tab"]'));
  
        tabs.forEach((tab, i) => {
          tab.addEventListener('click', () => this.select(tabs, tab));
  
          // 矢印キーで隣のタブへ移動する(WAI-ARIAのタブの操作)
          tab.addEventListener('keydown', (e) => {
            const keys = { ArrowRight: i + 1, ArrowLeft: i - 1, Home: 0, End: tabs.length - 1 };
            if (!(e.key in keys)) return;
            e.preventDefault();
            const next = tabs[(keys[e.key] + tabs.length) % tabs.length];
            this.select(tabs, next);
            next.focus();
          });
        });
      });
    }
  
    select(tabs, current) {
      tabs.forEach((tab) => {
        const isCurrent = tab === current;
        tab.classList.toggle('is-active', isCurrent);
        tab.setAttribute('aria-selected', isCurrent ? 'true' : 'false');
        tab.tabIndex = isCurrent ? 0 : -1;
        document.getElementById(tab.getAttribute('aria-controls')).hidden = !isCurrent;
      });
    }
  }
  
    // -------------------------------------------------
  // スクロール禁止 + スクロールバー幅のずれ補正
  // -------------------------------------------------
  let scrollTop = 0;
  let lockCount = 0;
  
  function getScrollbarWidth() {
    return window.innerWidth - document.documentElement.clientWidth;
  }
  
  function isScrollLocked() {
    return document.documentElement.classList.contains('is-hidden');
  }
  
  function lockBodyScroll() {
    lockCount += 1;
    if (lockCount > 1) return;
  
    const html = document.documentElement;
    const body = document.body;
    const scrollbarWidth = getScrollbarWidth();
  
    scrollTop = window.scrollY;
    html.style.top = `${scrollTop * -1}px`;
    html.classList.add('is-hidden');
  
    html.style.setProperty('--scrollbar-compensation', `${scrollbarWidth}px`);
    if (scrollbarWidth > 0) {
      body.style.paddingRight = `${scrollbarWidth}px`;
    }
  }
  
  function applyUnlockStyles() {
    const html = document.documentElement;
    const body = document.body;
    const restoreY = scrollTop;
  
    html.style.top = '';
    html.classList.remove('is-hidden');
    html.style.setProperty('--scrollbar-compensation', '0px');
    body.style.paddingRight = '';
  
    const prevHtmlBehavior = html.style.scrollBehavior;
    const prevBodyBehavior = body.style.scrollBehavior;
    html.style.scrollBehavior = 'auto';
    body.style.scrollBehavior = 'auto';
  
    window.scrollTo(0, restoreY);
  
    html.style.scrollBehavior = prevHtmlBehavior;
    body.style.scrollBehavior = prevBodyBehavior;
  }
  
  function unlockBodyScroll() {
    if (lockCount === 0) return;
    lockCount -= 1;
    if (lockCount > 0) return;
  
    applyUnlockStyles();
  }
  
  function forceUnlockBodyScroll() {
    if (lockCount === 0 && !document.documentElement.classList.contains('is-hidden')) {
      return;
    }
    lockCount = 0;
    applyUnlockStyles();
  }
  
  function scrollBan() {
    if (document.documentElement.classList.contains('is-hidden')) {
      forceUnlockBodyScroll();
    } else {
      lockBodyScroll();
    }
  }
  
    // ------------------------------------------
  // 横スクロールの位置バー
  // ------------------------------------------
  class ScrollBar {
    constructor(el, opt) {
      this.items = document.querySelectorAll('.' + el);
      if (this.items.length > 0) {
        this.event();
      }
    }
  
    event() {
      this.items.forEach((item) => {
        const area = item.querySelector('.js-scrollbar-area');
        const thumb = item.querySelector('.js-scrollbar-thumb');
        if (!area || !thumb) return;
  
        const update = () => {
          const track = thumb.parentElement;
          const trackWidth = track.clientWidth - thumb.offsetLeft * 2;
          const max = area.scrollWidth - area.clientWidth;
          if (max <= 0 || trackWidth <= 0) return;
  
          const thumbWidth = Math.max(trackWidth * (area.clientWidth / area.scrollWidth), trackWidth * 0.2);
          thumb.style.width = `${thumbWidth}px`;
          thumb.style.transform = `translateX(${(trackWidth - thumbWidth) * (area.scrollLeft / max)}px)`;
        };
  
        area.addEventListener('scroll', update, { passive: true });
        window.addEventListener('resize', update);
        update();
      });
    }
  }
  
    // ------------------------------------------
  // 私たちの4つの強み
  // ------------------------------------------
  class Strengths {
    constructor(el, opt) {
      this.items = Array.from(document.querySelectorAll('.' + el));
      if (this.items.length > 0) {
        this.duration = 0.3;
        this.limit = 6;
        this.alignMax = 12;
        this.cards = [];
        this.visible = false;
        this.event();
      }
    }
  
    event() {
      this.toggle();
      this.stack();
      this.inertia();
    }
  
    // ------------------------------
    // カードの重なり
    // ------------------------------
    stack() {
      this.update = this.update.bind(this);
  
      if ('ResizeObserver' in window) {
        const observer = new ResizeObserver(this.update);
        this.items.forEach((item) => observer.observe(item.querySelector('.p-top__strengths-inner') || item));
      }
  
      let timer;
      window.addEventListener('resize', () => {
        clearTimeout(timer);
        timer = setTimeout(this.update, 200);
      });
  
      window.addEventListener('load', this.update);
  
      this.update();
    }
  
    clearSpacing(list, heading) {
      list.style.removeProperty('--strengths-top');
      list.style.removeProperty('--strengths-space');
      list.style.marginTop = '';
      if (heading) heading.style.marginBottom = '';
      this.items.forEach((item) => {
        item.style.marginBottom = '';
        item.style.transform = '';
      });
    }
  
    update() {
      const list = this.items[0].parentElement;
      const section = list.parentElement;
      const heading = section.querySelector('.p-top__strengths-heading');
  
      if (window.matchMedia('(max-width: 767px)').matches) {
        section.style.removeProperty('--strengths-pin');
        section.style.removeProperty('--strengths-rest');
        this.clearSpacing(list, heading);
        this.cards = [];
        return;
      }
  
      const rem = parseFloat(getComputedStyle(document.documentElement).fontSize);
      const gap = parseFloat(getComputedStyle(list).marginTop) + parseFloat(getComputedStyle(heading).marginBottom);
  
      // 余白をリセットしてから実寸を測る
      this.clearSpacing(list, heading);
      list.style.setProperty('--strengths-top', heading.offsetHeight + gap + 'px');
  
      const measure = () => this.items.map((item) => {
        const style = getComputedStyle(item);
        return {
          item,
          top: parseFloat(style.top) || 0,
          height: item.offsetHeight,
        };
      });
      const bottomOf = (cards) => Math.max(...cards.map((card) => card.top + card.height));
  
      section.style.setProperty('--strengths-pin', '0px');
      const space = Math.round(window.innerHeight - bottomOf(measure()));
      const alignMax = this.alignMax * rem;
      const pin = Math.round(space <= alignMax ? space : Math.max(alignMax, space / 2));
      section.style.setProperty('--strengths-pin', pin + 'px');
  
      const cards = measure();
      const stackBottom = bottomOf(cards);
  
      section.style.setProperty('--strengths-rest', Math.max(0, Math.round(window.innerHeight - stackBottom)) + 'px');
  
      const release = Math.max(0, Math.round(stackBottom - pin - heading.offsetHeight));
      heading.style.marginBottom = release + 'px';
      list.style.marginTop = gap - release + 'px';
  
      // 固定が外れるタイミングを全カードで揃える（各カードの下端 + margin-bottom = stackBottom）
      cards.forEach((card, i) => {
        const isLast = i === cards.length - 1;
        card.space = isLast ? 0 : Math.max(0, Math.round(stackBottom - card.top - card.height));
        card.item.style.marginBottom = card.space + 'px';
        card.box = card.height + card.space;
      });
  
      const y = window.scrollY;
      let flow = list.getBoundingClientRect().top + y + (parseFloat(getComputedStyle(list).paddingTop) || 0);
      cards.forEach((card) => {
        card.flow = flow;
        flow += card.box;
        card.pos = Math.max(card.flow - y, card.top);
        card.item.style.transform = '';
      });
  
      this.listTop = cards[0].flow;
      this.limitPx = this.limit * rem;
      this.cards = cards;
    }
  
    // ------------------------------
    // 収まるときの余韻
    // ------------------------------
    inertia() {
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || typeof gsap === 'undefined') return;
  
      this.tick = this.tick.bind(this);
  
      const observer = new IntersectionObserver((entries) => {
        this.visible = entries[0].isIntersecting;
        this.visible ? this.start() : this.reset();
      }, { rootMargin: '20% 0px' });
      observer.observe(this.items[0].parentElement);
  
      window.addEventListener('scroll', () => this.start(), { passive: true });
    }
  
    start() {
      if (this.running || !this.visible) return;
      this.running = true;
      this.last = 0;
      gsap.ticker.add(this.tick);
    }
  
    reset() {
      this.cards.forEach((card) => {
        card.pos = Math.max(card.flow - window.scrollY, card.top);
        card.item.style.transform = '';
      });
    }
  
    // セクションを過ぎたあとは sticky / 慣性を即クリアする
    isPast() {
      if (!this.cards.length) return false;
      const last = this.cards[this.cards.length - 1];
      return window.scrollY > last.flow + last.height;
    }
  
    tick(seconds) {
      const time = seconds * 1000;
      const dt = Math.min(time - (this.last || time), 100) / 1000;
      this.last = time;
  
      if (!this.visible || this.isPast()) {
        gsap.ticker.remove(this.tick);
        this.reset();
        this.running = false;
        return;
      }
  
      const y = window.scrollY;
      let moving = false;
  
      this.cards.forEach((card, i) => {
        const target = Math.max(card.flow - y, card.top);
  
        if (i === 0) {
          card.pos = target;
          card.item.style.transform = '';
          return;
        }
  
        // すでに通過したカードは慣性をかけない（通過後に単体でずれるのを防ぐ）
        if (y > card.flow + card.height) {
          card.pos = target;
          card.item.style.transform = '';
          return;
        }
  
        const distance = target - card.pos;
  
        if (Math.abs(distance) > window.innerHeight) {
          card.pos = target;
        } else {
          const speed = this.duration / (1 + Math.abs(distance) / this.limitPx);
          card.pos += distance * (1 - Math.exp(-dt / speed));
        }
  
        let offset = card.pos - target;
        if (offset < 0) offset = Math.max(offset, -Math.max(0, target - (this.listTop - y)));
  
        if (Math.abs(offset) < 0.3) {
          card.pos = target;
          card.item.style.transform = '';
        } else {
          moving = true;
          card.item.style.transform = `translate3d(0, ${offset.toFixed(2)}px, 0)`;
        }
      });
  
      if (!moving) {
        gsap.ticker.remove(this.tick);
        this.reset();
        this.running = false;
      }
    }
  
    // ------------------------------
    // SPの開閉
    // ------------------------------
    toggle() {
      this.items.forEach((item) => {
        const btn = item.querySelector('.js-strength-toggle');
        if (!btn) return;
  
        btn.addEventListener('click', () => {
          const isOpen = item.classList.toggle('is-open');
          btn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
        });
      });
    }
  }
  
    class TopElementor {
    constructor(el,opt){
      this.el = el;
      if($("." + this.el).length > 0){
        this.event();
      }
    }
    event(){
      $('.js-elementor-drawer-trigger').on('click', function(){
        $('html').toggleClass('is-elementor-drawer-open');
        scrollBan();
      });
  
      let scrollTimer;
      $(window).on('scroll', function() {
        clearTimeout(scrollTimer);
        scrollTimer = setTimeout(function() {
          if($(window).scrollTop() > 100) {
            $('html').addClass('is-scroll');
          } else {
            $('html').removeClass('is-scroll');
          }
        }, 100);
      });
  
    }
  }
  
    // ------------------------------------------
  // お客様の声のモーダル
  // ------------------------------------------
  class VoiceModal {
    constructor(el, opt) {
      this.modal = document.querySelector('.' + el);
      if (this.modal) {
        this.slides = this.modal.querySelectorAll('.js-voice-slide');
        this.current = this.modal.querySelector('.js-voice-current');
        this.box = this.modal.querySelector('.js-voice-box');
        this.scrollbar = this.modal.querySelector('.js-voice-scrollbar');
        this.thumb = this.modal.querySelector('.js-voice-thumb');
        this.index = 0;
        this.drag = null;
        this.trap = new FocusTrap(this.modal.querySelector('[role="dialog"]') || this.modal);
        this.event();
      }
    }
  
    event() {
      document.querySelectorAll('.js-voice-open').forEach((btn, i) => {
        btn.addEventListener('click', () => this.open(i));
      });
  
      this.modal.querySelectorAll('.js-voice-close').forEach((btn) => {
        btn.addEventListener('click', () => this.close());
      });
  
      const prev = this.modal.querySelector('.js-voice-prev');
      const next = this.modal.querySelector('.js-voice-next');
      if (prev) prev.addEventListener('click', () => this.goTo(this.index - 1, -1));
      if (next) next.addEventListener('click', () => this.goTo(this.index + 1, 1));
  
      document.addEventListener('keydown', (e) => {
        if (!this.modal.classList.contains('is-open')) return;
        if (e.key === 'Escape') this.close();
        if (e.key === 'ArrowLeft') this.goTo(this.index - 1, -1);
        if (e.key === 'ArrowRight') this.goTo(this.index + 1, 1);
      });
  
      let startX = null;
      this.box.addEventListener('touchstart', (e) => {
        startX = e.changedTouches[0].clientX;
      }, { passive: true });
      this.box.addEventListener('touchend', (e) => {
        if (startX === null) return;
        const dx = e.changedTouches[0].clientX - startX;
        if (Math.abs(dx) > 50) this.goTo(this.index + (dx < 0 ? 1 : -1), dx < 0 ? 1 : -1);
        startX = null;
      });
  
      this.bindScrollbar();
    }
  
    bindScrollbar() {
      if (!this.scrollbar || !this.thumb) return;
  
      const update = () => this.updateScrollbar();
      this.box.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      this.box.querySelectorAll('img').forEach((img) => {
        img.addEventListener('load', update);
      });
      if (window.ResizeObserver) {
        const observer = new ResizeObserver(update);
        observer.observe(this.box);
      }
  
      this.thumb.addEventListener('pointerdown', (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.drag = { y: e.clientY, scroll: this.box.scrollTop };
        this.thumb.setPointerCapture(e.pointerId);
      });
      this.thumb.addEventListener('pointermove', (e) => {
        if (!this.drag) return;
        const travel = this.scrollbar.clientHeight - this.thumb.offsetHeight;
        const max = this.box.scrollHeight - this.box.clientHeight;
        if (travel <= 0 || max <= 0) return;
        this.box.scrollTop = this.drag.scroll + (e.clientY - this.drag.y) * (max / travel);
      });
      const endDrag = () => {
        this.drag = null;
      };
      this.thumb.addEventListener('pointerup', endDrag);
      this.thumb.addEventListener('pointercancel', endDrag);
  
      this.scrollbar.addEventListener('pointerdown', (e) => {
        if (e.target === this.thumb) return;
        const rect = this.scrollbar.getBoundingClientRect();
        const travel = rect.height - this.thumb.offsetHeight;
        const max = this.box.scrollHeight - this.box.clientHeight;
        if (travel <= 0 || max <= 0) return;
        const ratio = (e.clientY - rect.top - this.thumb.offsetHeight / 2) / travel;
        this.box.scrollTop = Math.min(Math.max(ratio, 0), 1) * max;
      });
    }
  
    updateScrollbar() {
      if (!this.scrollbar || !this.thumb) return;
      const max = this.box.scrollHeight - this.box.clientHeight;
      const show = max > 1;
      this.scrollbar.classList.toggle('is-hidden', !show);
      if (!show) return;
  
      const track = this.scrollbar.clientHeight;
      const thumbH = Math.max(track * (this.box.clientHeight / this.box.scrollHeight), Math.min(track * 0.12, track));
      const y = (track - thumbH) * (this.box.scrollTop / max);
      this.thumb.style.height = `${thumbH}px`;
      this.thumb.style.transform = `translateY(${y}px)`;
    }
  
    open(index) {
      this.modal.classList.add('is-instant');
      this.goTo(index, 1);
      this.modal.offsetHeight;
      this.modal.classList.remove('is-instant');
      this.modal.classList.add('is-open');
      this.modal.setAttribute('aria-hidden', 'false');
      lockBodyScroll();
      this.trap.activate(this.modal.querySelector('.p-top__voice-modal-close'));
      this.updateScrollbar();
    }
  
    close() {
      if (!this.modal.classList.contains('is-open')) return;
      this.modal.classList.remove('is-open');
      this.modal.setAttribute('aria-hidden', 'true');
      unlockBodyScroll();
      this.trap.deactivate();
    }
  
    goTo(index, dir = 1) {
      const total = this.slides.length;
      const prev = this.index;
      this.index = (index + total) % total;
      this.slides.forEach((slide, i) => {
        slide.style.setProperty('--dir', dir);
        slide.classList.toggle('is-leave', i === prev && i !== this.index);
        slide.classList.toggle('is-active', i === this.index);
      });
      if (this.current) this.current.textContent = this.index + 1;
      this.box.scrollTop = 0;
      this.updateScrollbar();
    }
  }
  
    // ------------------------------------------
  // 選択した項目のURLへ移動するセレクト（施工事例の絞り込み）
  // ------------------------------------------
  class WorksLinkSelect {
    constructor(el, opt) {
      document.querySelectorAll('.' + el).forEach((select) => {
        select.addEventListener('change', () => {
          if (select.value) window.location.href = select.value;
        });
      });
    }
  }
  
    // ------------------------------------------
  // 施工事例詳細の関連事例スライダー
  // ------------------------------------------
  class WorksRelatedSlider {
    constructor(el) {
      this.sliders = document.querySelectorAll('.' + el);
      if (this.sliders.length > 0 && typeof Swiper !== 'undefined') {
        this.sliders.forEach((slider) => this.setup(slider));
      }
    }
  
    setup(slider) {
      const container = slider.querySelector('.swiper-container');
      const count = slider.querySelectorAll('.swiper-slide').length;
      if (count < 2) return;
  
      new Swiper(container, {
        slidesPerView: 'auto',
        spaceBetween: 13,
        loop: true,
        loopedSlides: count,
        speed: 800,
        grabCursor: true,
        navigation: {
          prevEl: slider.querySelector('.js-works-related-prev'),
          nextEl: slider.querySelector('.js-works-related-next'),
        },
        pagination: {
          el: slider.querySelector('.js-works-related-pagination'),
          clickable: true,
          bulletClass: 'p-works-single__related-bullet',
          bulletActiveClass: 'is-active',
          renderBullet: (i, className) => `<button class="${className}" type="button" aria-label="${i + 1}件目へ"></button>`,
        },
        breakpoints: {
          0: { spaceBetween: 4, centeredSlides: true },
          768: { spaceBetween: 13, centeredSlides: false },
        },
      });
    }
  }
  
    // ------------------------------------------
  // 施工事例のカルーセル
  // ------------------------------------------
  class WorksSlider {
    constructor(el, opt) {
      this.items = document.querySelectorAll('.' + el);
      if (this.items.length > 0) {
        this.duration = 1.2;
        this.dragThreshold = 6;
        // 少し動かしただけで隣へ切り替える距離と、素早く払ったときの距離・時間(Swiperの短いスワイプ相当)
        this.swipeDistance = 20;
        this.flickDistance = 8;
        this.flickTime = 300;
        this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.sliders = Array.from(this.items).map((item) => this.setup(item));
        this.event();
      }
    }
  
    setup(item) {
      const s = {
        view: item.querySelector('.js-works-view'),
        track: item.querySelector('.js-works-track'),
        link: item.querySelector('.js-works-link'),
        dots: item.querySelectorAll('.js-works-dots'),
        originals: [],
        lefts: [],
        setWidth: 0,
        shift: 0,
        min: 0,
        max: 0,
        x: 0,
        index: 0,
        active: null,
        move: null,
        isMoving: false,
        isHover: false,
        hoverSlide: null,
        mouse: { x: 0, y: 0 },
        drag: null,
        isDragged: false,
      };
      s.originals = Array.from(s.track.children);
  
      this.bindDrag(s);
      this.bindClick(s);
      this.bindHover(s);
      this.bindDots(s);
      return s;
    }
  
    event() {
      this.build();
  
      let timer;
      window.addEventListener('resize', () => {
        clearTimeout(timer);
        timer = setTimeout(() => this.build(), 200);
      });
    }
  
    // ------------------------------
    // 無限ループ用の複製
    // ------------------------------
    build() {
      this.sliders.forEach((s) => {
        s.track.querySelectorAll('.is-clone').forEach((clone) => clone.remove());
  
        const first = s.originals[0];
        const last = s.originals[s.originals.length - 1];
        const gap = parseFloat(getComputedStyle(s.track).columnGap) || 0;
        const originLeft = first.offsetLeft;
        s.setWidth = last.offsetLeft + last.offsetWidth + gap - originLeft;
        s.lefts = s.originals.map((slide) => slide.offsetLeft - originLeft);
        s.shift = 0;
        if (!s.setWidth) return;
  
        const makeClone = (slide) => {
          const clone = slide.cloneNode(true);
          clone.classList.add('is-clone');
          clone.setAttribute('aria-hidden', 'true');
          clone.querySelectorAll('img').forEach((img) => {
            img.loading = 'eager';
          });
          return clone;
        };
  
        // ホバー中は1周戻す処理をしないので、その間に何周かドラッグできるよう多めに複製する
        const copies = Math.ceil(s.view.clientWidth / s.setWidth) + 3;
        for (let i = 0; i < copies; i++) {
          s.originals.forEach((slide) => s.track.appendChild(makeClone(slide)));
        }
        for (let i = 0; i < copies; i++) {
          for (let j = s.originals.length - 1; j >= 0; j -= 1) {
            s.track.insertBefore(makeClone(s.originals[j]), s.track.firstChild);
          }
        }
  
        s.shift = first.offsetLeft - originLeft;
        s.min = s.view.clientWidth - copies * s.setWidth;
        s.max = (copies - 1) * s.setWidth;
  
        this.jumpTo(s, s.index);
      });
    }
  
    // ------------------------------
    // ドラッグ(スマホはスワイプ)
    // ------------------------------
    bindDrag(s) {
      s.view.addEventListener('pointerdown', (e) => {
        if (!e.isPrimary || e.button !== 0) return;
  
        if (s.move) s.move.kill();
        s.isMoving = false;
        s.drag = { pointerId: e.pointerId, startX: e.clientX, startPos: s.x, startIndex: this.nearest(s), startTime: Date.now() };
        s.isDragged = false;
      });
  
      // 写真の外までドラッグしても追えるように、動きと離したときは window で受け取る
      const dragMove = (e) => {
        if (!s.drag || e.pointerId !== s.drag.pointerId) return;
  
        const dx = e.clientX - s.drag.startX;
        if (!s.isDragged && Math.abs(dx) > this.dragThreshold) {
          s.isDragged = true;
          s.view.classList.add('is-dragging');
        }
  
        if (s.isDragged) {
          s.x = s.drag.startPos + dx;
          this.keepInRange(s);
          this.render(s);
        }
      };
      window.addEventListener('pointermove', dragMove);
  
      const dragEnd = (e) => {
        if (!s.drag || e.pointerId !== s.drag.pointerId) return;
  
        if (e.type === 'pointerup') dragMove(e);
        const { startPos, startIndex, startTime } = s.drag;
        s.drag = null;
        s.view.classList.remove('is-dragging');
  
        if (s.isDragged) {
          const dx = s.x - startPos;
          const isFlick = Date.now() - startTime < this.flickTime && Math.abs(dx) >= this.flickDistance;
          if (Math.abs(dx) >= this.swipeDistance || isFlick) {
            const forward = dx < 0;
            const count = s.lefts.length;
            this.goTo(s, (startIndex + (forward ? 1 : -1) + count) % count, forward);
          } else {
            this.goTo(s, this.nearest(s));
          }
        }
      };
      window.addEventListener('pointerup', dragEnd);
      window.addEventListener('pointercancel', dragEnd);
  
      // リンクをつかむブラウザ標準のドラッグが始まると、スライドが途中で止まるため
      s.link.addEventListener('dragstart', (e) => e.preventDefault());
    }
  
    // ------------------------------
    // ドラッグした直後はページを開かない
    // ------------------------------
    bindClick(s) {
      s.link.addEventListener('click', (e) => {
        if (s.isDragged) e.preventDefault();
      });
    }
  
    // ------------------------------
    // ホバー中の拡大
    // ------------------------------
    bindHover(s) {
      const enter = (e) => {
        if (e.pointerType !== 'mouse') return;
        s.isHover = true;
        s.mouse = { x: e.clientX, y: e.clientY };
        this.updateHover(s);
      };
      s.view.addEventListener('pointerenter', enter);
      s.view.addEventListener('pointermove', enter);
  
      s.view.addEventListener('pointerleave', (e) => {
        if (e.pointerType !== 'mouse') return;
        s.isHover = false;
        this.updateHover(s);
      });
    }
  
    // CSSの :hover はマウスを止めたまま写真が動くと数秒切り替わらないため、写真が動くたびに判定し直す
    updateHover(s) {
      let slide = null;
      if (s.isHover) {
        slide = document.elementFromPoint(s.mouse.x, s.mouse.y);
        while (slide && slide.parentElement !== s.track) slide = slide.parentElement;
      }
      if (slide === s.hoverSlide) return;
  
      if (s.hoverSlide) s.hoverSlide.classList.remove('is-hover');
      if (slide) slide.classList.add('is-hover');
      s.hoverSlide = slide;
    }
  
    // ------------------------------
    // ドットで移動
    // ------------------------------
    bindDots(s) {
      s.dots.forEach((group) => {
        group.querySelectorAll('.js-works-dot').forEach((dot, i) => {
          dot.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            this.goTo(s, i);
          });
        });
      });
    }
  
    // ------------------------------
    // 位置の計算
    // ------------------------------
    // 1周ずれた同じ見た目の位置へ戻す
    // マウスの下の画像が複製と入れ替わり、ホバーの拡大が途切れるので、ホバーしていない自動送りの前だけで行う
    normalize(s, x) {
      if (!s.setWidth) return x;
      let next = x % s.setWidth;
      if (next > 0) next -= s.setWidth;
      return next;
    }
  
    keepInRange(s) {
      let offset = 0;
      if (s.x > s.max) offset = -s.setWidth;
      if (s.x < s.min) offset = s.setWidth;
      if (!offset) return;
  
      s.x += offset;
      if (s.drag) s.drag.startPos += offset;
    }
  
    targetOf(s, index, forward) {
      const target = -s.lefts[index];
  
      if (forward) return target > s.x ? target - s.setWidth : target;
  
      return target + Math.round((s.x - target) / s.setWidth) * s.setWidth;
    }
  
    nearest(s) {
      const x = this.normalize(s, s.x);
      let index = 0;
      let min = Infinity;
      s.lefts.forEach((left, i) => {
        [-left, -left - s.setWidth, -left + s.setWidth].forEach((pos) => {
          const diff = Math.abs(pos - x);
          if (diff < min) {
            min = diff;
            index = i;
          }
        });
      });
      return index;
    }
  
    // ------------------------------
    // 移動
    // ------------------------------
    jumpTo(s, index) {
      if (!s.setWidth) return;
      s.index = index;
      s.x = -s.lefts[index];
      this.render(s);
      this.updateDots(s);
    }
  
    goTo(s, index, forward) {
      if (!s.setWidth || typeof gsap === 'undefined') {
        this.jumpTo(s, index);
        return;
      }
      if (s.move) s.move.kill();
  
      const to = this.targetOf(s, index, forward);
  
      if (to === s.x) {
        s.index = index;
        this.updateDots(s);
        return;
      }
  
      s.isMoving = true;
      s.move = gsap.to(s, {
        x: to,
        duration: this.reduced ? 0 : this.duration,
        ease: 'power2.inOut',
        onUpdate: () => {
          this.render(s);
          this.updateDots(s);
        },
        onComplete: () => {
          s.index = index;
          s.isMoving = false;
          this.render(s);
          this.updateDots(s);
        },
      });
    }
  
    render(s) {
      const dpr = window.devicePixelRatio || 1;
      const x = s.x - s.shift;
      s.track.style.transform = `translate3d(${Math.round(x * dpr) / dpr}px, 0, 0)`;
      this.updateHover(s);
    }
  
    // ------------------------------
    // ドット
    // ------------------------------
    updateDots(s) {
      const index = this.nearest(s);
      if (index === s.active) return;
  
      s.active = index;
      s.dots.forEach((group) => {
        group.querySelectorAll('.js-works-dot').forEach((dot, i) => {
          dot.classList.toggle('is-active', i === index);
        });
      });
    }
  }
  

  // ページ読み込みが完了したら100%に設定し、しばらく後にバーを消す
  window.addEventListener('load', () => {
    setTimeout(() => {
      $('.js-loading').fadeOut();
    }, 1500);
  });

  (() => {

    let imgParallax = new ImgParallax('js-parallax');
    let inviewEvent = new InviewEvent('js-inview');
    let header = new Header('js-header');

    // ------------------------------
    // トップページ用
    // ------------------------------
    let top = new Top('p-top');
    let fvScroll = new FvScroll('js-fv');
    let fvSlider = new FvSlider('js-fv');
    let worksSlider = new WorksSlider('js-works');
    let scrollBar = new ScrollBar('js-scrollbar');
    let voiceModal = new VoiceModal('js-voice-modal');
    let marquee = new Marquee('js-marquee');
    let strengths = new Strengths('js-strength');
    let faqAccordion = new FaqAccordion('js-faq-toggle');
    let newsTab = new NewsTab('js-news-tab');

    // ------------------------------
    // 施工事例・アイデア集
    // ------------------------------
    let linkSelect = new WorksLinkSelect('js-works-link-select');
    let relatedSlider = new WorksRelatedSlider('js-works-related-slider');
    let ideaModal = new IdeaModal('js-idea-modal');
    let contactDate = new ContactDate('input[type="date"]');
    let contactConfirm = new ContactConfirm('.c-confirm__btns input[type="button"]');

    // ------------------------------
    // ページビルダー用
    // ------------------------------
    let topElementor = new TopElementor('js-topElementor');
    let modal = new Modal('js-modal');
    let accordion = new Accordion('js-accordion');
    let editor = new Editor('c-content');

  })();

  //DOMContentLoaded
  $(() => {
  });

  //images resources loaded
  $(window).on('load', () => {

    $(window).trigger('loading');
  });

  //after loading animation
  $(window).on('loading', () => {
  });
})(jQuery);